import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-order-tracking-detail',
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './order-tracking-detail.component.html',
  styleUrl: './order-tracking-detail.component.scss'
})
export class OrderTrackingDetailComponent implements OnInit {
  selectedOrder: any = {};

  constructor(private route: ActivatedRoute, private router: Router, public dialogRef: MatDialogRef<OrderTrackingDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.selectedOrder = JSON.parse(data.data);
    }
  ngOnInit(): void {
    // this.route.queryParams.subscribe(params => {
    //   this.selectedOrder = JSON.parse(params["data"]);
    // });
  }

  navigateToGoogleMaps(order: any) {
    this.close();
    this.router.navigate(['/home/shipping-order/order-tracking/detail/maps'], 
      {queryParams: {data: JSON.stringify(order)}});
  }
  close(): void {
    this.dialogRef.close();
  }
}
